var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2CloudNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6 31.89a15.2 15.2 0 01-11.52 7.69 15.54 15.54 0 00-10.16-5.26 19.52 19.52 0 00-7-9.76A15.28 15.28 0 0156.64 9.27c-3.12 4.31-2.75 11.09 1.3 16.49 3.84 5.12 9.79 7.42 14.66 6.13zM60.91 50.5A11.48 11.48 0 0149.51 62h-34.3A11.498 11.498 0 014.516 46.145 11.5 11.5 0 0115.11 39h1.7a15.62 15.62 0 0117.48-13.4A15.49 15.49 0 0147.71 39h1.7a11.5 11.5 0 0111.5 11.5zm-3.9 0a7.55 7.55 0 00-7.5-7.5h-5.6v-2a11.68 11.68 0 00-11.72-11.3H32A11.69 11.69 0 0020.71 41v2h-5.6a7.449 7.449 0 00-7.5 7.45 7.58 7.58 0 007.5 7.6h34.4A7.491 7.491 0 0057 50.5h.01z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Cloud_night.37660c34.svg";
export { SvgB2CloudNight as ReactComponent };